module.exports = __webpack_public_path__ + "static/media/logo-2-white.bb6fbe04.png";